<div class="modal-header">
    <h4 class="modal-title pull-left">{{ title }}
    </h4>
    <button type="button"
            class="close pull-right"
            aria-label="Close"
            (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div #container></div>
</div>
<div class="modal-footer">

    <button *ngFor="let button of additionalButtons"
            [class]="button.cssClass || 'btn btn-secondary'"
            [disabled]="isButtonDisabled(button)"
            (click)="onButtonClick(button)">
        {{ button.label | translate }}
    </button>

    <div style="margin-left: auto">
        <button *ngIf="showOk" class="btn btn-success" [disabled]="!valid" (click)="ok()">{{'common.ok' | translate}}</button>
        <button *ngIf="showCancel" class="btn btn-success ml-2" (click)="dismiss()">{{'common.cancel' | translate}}</button>
    </div>
</div>
